import { useInView } from '@/hooks/useInView';

export default function CTASection() {
  const [ref, isInView] = useInView();

  return (
    <section ref={ref} className="relative w-full py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Aerial%20flat%20lay%20of%20diverse%20fashion%20and%20lifestyle%20products%20including%20sneakers%20leather%20goods%20watches%20and%20accessories%20arranged%20in%20vibrant%20organized%20grid%20pattern%20on%20textured%20warm%20cork%20board%20surface%2C%20bright%20natural%20daylight%20from%20skylight%20above%2C%20energetic%20modern%20ecommerce%20photography%2C%20rich%20varied%20textures%2C%20dynamic%20colorful%20composition%20with%20intentional%20order&width=1600&height=800&seq=cta-bg-v2&orientation=landscape"
          alt="Mulebuy spreadsheet vibrant fashion collection flat lay with diverse products on cork surface"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/55"></div>
      </div>

      <div className={`relative z-10 max-w-[1400px] mx-auto px-6 md:px-10 transition-all duration-700 ease-out ${isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-10">
          <div className="lg:max-w-xl">
            <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-[1.05] lowercase mb-0">
              mulebuy spreadsheets
            </h2>
          </div>

          <div className="flex flex-col items-start lg:items-end gap-8 lg:gap-10 lg:max-w-sm">
            <div className="space-y-2">
              <p className="text-base md:text-lg text-background-200 leading-relaxed">
                Daily updated product listings from verified agents.
              </p>
              <p className="text-base md:text-lg text-background-200 leading-relaxed">
                Safe, transparent, community-approved selections for European and American shoppers.
              </p>
            </div>

            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-4 px-8 py-4 rounded-full bg-background-50 text-foreground-950 text-sm font-semibold whitespace-nowrap hover:bg-background-100 transition-all duration-300 hover:scale-[1.03] cursor-pointer group"
            >
              Buy It Now
              <span className="w-7 h-7 rounded-full bg-foreground-950 flex items-center justify-center group-hover:bg-accent-600 transition-colors">
                <i className="ri-arrow-right-line text-xs text-background-50"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}